module.exports = __webpack_public_path__ + "r-v3/img/screen_none.31e55d84.svg";